import React from "react";
import styled from "styled-components";
import HeroImage from "../../assets/heroImage.jpg";

const HeroSection = () => {
  return (
    <TheHero>
      <div className="overlay"></div>
      <div className="hero-img">
        <img src={HeroImage} alt="hero-background" />
      </div>
      <div className="hero-content">
        <h3>Agroharvest Machineries</h3>
        <p className="fast">Fast, Reliable, Efficient & Local</p>
        <p className="need">The equipment you need is a click away</p> <br />
        <a href="/equipments" className="btn-secondary">
          Explore Equipment
        </a>
      </div>
    </TheHero>
  );
};

const TheHero = styled.div`
  width: 100%;
  height: 60vh;
  position: relative;
  overflow: hidden;

  .overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
  }

  .hero-img {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .hero-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 0.5rem;

    h3 {
      font-size: 4rem;
      font-weight: 600;
    }

    .fast {
      font-size: 2.5rem;
      font-weight: 400;
    }

    .need {
      font-size: 1.5rem;
      font-weight: 400;
    }

    .btn-secondary {
      border: none;
      background: var(--third-color);
      color: var(--primary-color);
      padding: 0.8rem 2rem;
      border-radius: 0.5rem;
      cursor: pointer;
      transition: var(--transition);
      font-size: 1rem;
      font-weight: 600;
      text-decoration: none;
      display: inline-block;

      &:hover {
        background: var(--primary-color);
        color: var(--second-color);
      }
    }
  }

  /* Large desktop screens (1366px and below) */
  @media screen and (max-width: 1366px) {
    .hero-content {
      h3 {
        font-size: 3.5rem;
      }
      .fast {
        font-size: 2.2rem;
      }
      .need {
        font-size: 1.3rem;
      }
    }
  }

  /* Standard desktop / laptop (1200px and below) */
  @media screen and (max-width: 1200px) {
    height: 55vh;
    .hero-content {
      gap: 0.4rem;
      h3 {
        font-size: 3rem;
      }
      .fast {
        font-size: 2rem;
      }
      .need {
        font-size: 1.2rem;
      }
      .btn-secondary {
        padding: 0.7rem 1.8rem;
        font-size: 0.95rem;
      }
    }
  }

  /* Tablets (900px and below) */
  @media screen and (max-width: 900px) {
    height: 50vh;
    .hero-content {
      gap: 0.3rem;
      h3 {
        font-size: 2.5rem;
      }
      .fast {
        font-size: 1.6rem;
      }
      .need {
        font-size: 1rem;
      }
      .btn-secondary {
        padding: 0.6rem 1.5rem;
        font-size: 0.9rem;
      }
    }
  }

  /* Mobile landscape / small tablets (600px and below) */
  @media screen and (max-width: 600px) {
    height: 45vh;
    .hero-content {
      width: 90%;
      gap: 0.2rem;
      h3 {
        font-size: 1.8rem;
      }
      .fast {
        font-size: 1.2rem;
      }
      .need {
        font-size: 0.9rem;
      }
      .btn-secondary {
        padding: 0.5rem 1.2rem;
        font-size: 0.85rem;
      }
    }
  }

  /* Mobile portrait (420px and below) */
  @media screen and (max-width: 420px) {
    height: 40vh;
    .hero-content {
      width: 95%;
      h3 {
        font-size: 1.4rem;
      }
      .fast {
        font-size: 1rem;
      }
      .need {
        font-size: 0.8rem;
      }
      .btn-secondary {
        padding: 0.4rem 1rem;
        font-size: 0.8rem;
      }
    }
  }

  /* Small mobile devices (350px and below) */
  @media screen and (max-width: 350px) {
    height: 35vh;
    .hero-content {
      h3 {
        font-size: 1.2rem;
      }
      .fast {
        font-size: 0.9rem;
      }
      .need {
        font-size: 0.7rem;
      }
      .btn-secondary {
        padding: 0.35rem 0.9rem;
        font-size: 0.75rem;
      }
    }
  }
`;

export default HeroSection;
